// extracted by mini-css-extract-plugin
module.exports = {"alert":"Alert_alert__1OQpC","alert__content":"Alert_alert__content__1kpfO","alert__icon":"Alert_alert__icon__13bsE","alert__text":"Alert_alert__text__Tc6F-"};